var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.initializing)?[_vm._m(0)]:(_vm.initializationError)?[_vm._m(1)]:[_c('PromotionChangeForm',{attrs:{"user":_vm.user,"project":_vm.project}})]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-container"},[_c('div',{staticClass:"uk-margin",attrs:{"uk-spinner":"ratio: 3"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-container"},[_c('p',[_vm._v("Error initializing. Please refresh the page.")])])
}]

export { render, staticRenderFns }